import { ValueOf } from "next/dist/shared/lib/constants"
import { A } from "src/components/unstyled/A"
import { Img } from "src/components/unstyled/Img"
import { META_DATA } from "src/metadata/constants"
import { toImageCdnUrl } from "src/utilities/images"

const channelUrl = META_DATA.socials.youtube

/** https://github.com/paulirish/lite-youtube-embed/blob/master/youtube-thumbnail-urls.md */
export const ytPreviewQualities = {
  sm: { width: 480, name: "hqdefault" },
  md: { width: 640, name: "sddefault" },
  lg: { width: 1280, name: "maxresdefault" },
} as const

export function buildYtPreviewUrl(videoId: string, quality: ValueOf<typeof ytPreviewQualities>) {
  return `https://i.ytimg.com/vi_webp/${videoId}/${quality.name}.webp`
}

export type YouTubeImageProps = {
  videoId: string
  videoTitle: string
}

export const YouTubeImage = ({ videoId, videoTitle }: YouTubeImageProps) => {
  const videoUrl = `https://www.youtube.com/watch?v=${videoId}`
  const playLabel = `Video abspielen: ${videoTitle}`
  const src = toImageCdnUrl(buildYtPreviewUrl(videoId, ytPreviewQualities.sm))
  const srcSet = Object.values(ytPreviewQualities)
    .map((quality) => `${toImageCdnUrl(buildYtPreviewUrl(videoId, quality))} ${quality.width}w`)
    .join(", ")
  const sizes = "100vw"
  const T = de

  return (
    <>
      <Img
        src={src}
        srcSet={srcSet}
        sizes={sizes}
        alt={playLabel}
        loading="eager"
        className="absolute inset-0 object-cover"
      />

      <div className="pointer-events-none absolute top-0 h-16 w-full bg-linear-to-b from-black/75 to-black/0" />
      <div className="pointer-events-none absolute bottom-0 h-16 w-full bg-linear-to-t from-black/75 to-black/0" />

      <div className="absolute top-0 left-0 z-10 flex w-full overflow-hidden">
        <A
          href={channelUrl}
          className="flex h-full shrink-0 items-stretch p-3"
          title={T.channelLinkLabel}
          aria-label={T.channelLinkLabel}
        >
          <Img
            src="/assets/youtube.jpg"
            alt={META_DATA.brandName + " Logo"}
            loading="eager"
            width={40}
            height={40}
            className="rounded-full bg-gray-200"
          />
        </A>

        <A
          href={videoUrl}
          className="font-youtube text-shadow flex w-full items-center overflow-hidden text-lg font-normal"
          title={T.videoLinkLabel}
        >
          <div className="text-shadow truncate text-[18px] text-white">{videoTitle}</div>
        </A>
      </div>
    </>
  )
}

const de = {
  channelLinkLabel: "YouTube-Kanal",
  videoLinkLabel: "YouTube-Video",
  playLabel: "Video abspielen",
}
